
jQuery(document).foundation();

jQuery.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  return elementBottom > viewportTop && elementTop < viewportBottom;
};

(function ($) {

  // expandable card (e.g training details, team detail)
  // data-expandable-panels-container: selector of detail panels container
  // data-expandable-columns: how many columns on each breakpoint: small, medium, large
  // every expandable card/div under data-expandable-container must have
  // attribute "data-expandable" and "data-target" containing id of detail panel
  $("[data-expandable-container]").each(function() {
    $(this).on("click", "[data-expandable]", function(e) {
      e.preventDefault();
      var $selectedExpandable = $(this);
      var $selectedParent = $selectedExpandable.parent();
      var $selectedSiblings = $selectedExpandable.siblings('[data-expandable]');
      var $panelsContainer = $($selectedExpandable.parents('[data-expandable-container]').data('expandable-panels-container'));
      var columnSettings = $selectedExpandable.parents('[data-expandable-container]').data('expandable-columns');
      if (!columnSettings) columnSettings = "1,2,3";
      // reset classes
      $selectedSiblings.removeClass('expanded');
      $selectedSiblings.removeClass('collapsed');
      // collapse current opened card, if clicked again
      if ($selectedExpandable.is('.expanded')) {
        $selectedExpandable.removeClass('expanded');
        $selectedParent.children().not('[data-expandable]').remove();
        $('html,body').animate({scrollTop: $selectedExpandable.offset().top - 120}, 'slow');
      // expand selected card
      } else {
        $selectedExpandable.removeClass('collapsed').addClass('expanded');
        $selectedSiblings.addClass('collapsed');
        $selectedParent.children().not('[data-expandable]').appendTo($panelsContainer);
        // which card to put the detail after? this depends on current breakpoint
        // data-expandable-columns contains small,medium,large
        var targetId = $selectedExpandable.data('target');
        columnSettings = columnSettings.split(',');
        var multiplier = 1;
        var currentBreakpoint = Foundation.MediaQuery.current;
        if (currentBreakpoint == 'small') {
          multiplier = parseInt(columnSettings[0]);
        } else if (currentBreakpoint == 'medium') {
          multiplier = parseInt(columnSettings[1]);
        } else { // add another if, if xlarge is included
          multiplier = parseInt(columnSettings[2]);
        }
        for (var i=$selectedExpandable.index()+1; (i % multiplier) > 0; i++);
        i = Math.min(i, $selectedParent.children().length);
        var $targetDetailPanel = $panelsContainer.find('#'+targetId);
        var $targetCloned = $targetDetailPanel.clone();
        $targetCloned.insertAfter($selectedParent.children().eq(i-1));
        $targetCloned.foundation();
        $('html,body').animate({scrollTop: $targetCloned.offset().top - 140}, 'slow');
      }
    });
  });

  // for card close button
  $('body').on('click', "[data-expandable-close]", function() {
    var $selectedExpandable = $(this).parents('[data-expandable-container]').find("[data-expandable].expanded");
    $selectedExpandable.trigger('click');
  });

  // prevent default behavior for links with empty href
  $('body').on('click', 'a[href="#"]', function(e) {
    e.preventDefault();
  });

  var $window = $(window);
  var latestBreakpoint = 'none';

  $window.on('resize', function() {
    //adjust main's margin and padding according to header's height
    var headerHeight = $('header').outerHeight();
    $('main > *:first-child').css({
      'padding-top': headerHeight * (Foundation.MediaQuery.current == 'small' ? 1 : 1.25),
    });
    // remove opened expanable panel on breakpoint change
    if (latestBreakpoint != Foundation.MediaQuery.current) {
      latestBreakpoint = Foundation.MediaQuery.current;
      $("[data-expandable].expanded").trigger('click');
    }
  }).trigger('resize');

  // on scroll change header class
  var $headerScroll = $('header.scroll-change');
  if ($headerScroll.length > 0) {
    $window.on("scroll", function() {
      var offset = 32;
      if ($window.scrollTop() > offset) {
        $headerScroll.addClass('solid');
      } else {
        $headerScroll.removeClass('solid');
      }
    });
  }

  // "select" all header menu if none is
  var $headerMenu = $(".header-menu");
  if ($headerMenu.find('.page-nav.current').length == 0) {
    $headerMenu.find('.page-nav').addClass('current');
  }

  // gif handler
  // for now, assume only one gif instance per page
  /*
  if ($('#controllable-gif').length > 0) {
    var ctrlGifFirstScroll = false;
    var ctrlGif = new SuperGif({
      gif: document.getElementById('controllable-gif'),
      show_progress_bar: 0,
      auto_play: 0,
      loop_mode: true,
    });
    ctrlGif.load(function() {
      var $gifCanvas = $(ctrlGif.get_canvas());
      if ($gifCanvas.isInViewport()) {
        ctrlGif.play();
      }
      $gifCanvas
        .on("mouseenter", 
          function() {
            ctrlGif.play();
          }
        ).on("mouseleave", 
          function() {
            //ctrlGif.pause(); 20210104 request: keep animating on mouse leave
          }
        );
      $window.on('scroll', function() {
        if ($gifCanvas.isInViewport()) {
          if (!ctrlGifFirstScroll) {
            ctrlGif.play();
            ctrlGifFirstScroll = true;  
          }
        } else {
          ctrlGif.pause();
        }
      });
    });
  }
  */

  // cosmetics, rather than overriding post password template, 
  $window.on("load", function() {
    $(".post-password-form").children().each(function(){
      var str = this.innerHTML;
      this.innerHTML = str.replace(":", "<br>");
    });

    var footerHeight = $('body').find('footer').outerHeight();    
    $('main').css({
      'min-height': 'calc(100vh - '+footerHeight+'px)'
    })
  });

  // mobile menu
  $('.js-mobile-trigger, .js-mobile-menu-close').on('click', function (e) {
    $('body').toggleClass('mobile-menu--is-showing')
  });

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  });

  // debugger
  $window.on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize');

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})(jQuery);
